// extracted by mini-css-extract-plugin
module.exports = {"input-wrapper":"Input_input-wrapper__1__sE","input":"Input_input__1f87r","input__label":"Input_input__label__1O-xF"};